import { DsMapInterface } from '../interfaces/ds-map.interface';
import { DsDetailedMapInterface } from '../interfaces/ds-detailed-map.interface';

/**
 * Ds Map (used to be called plan) class
 */
export class DsMap {
  /**
   * The map id
   */
  id: number;

  /**
   * The map title
   */
  name: string;

  /**
   * Name of the category
   */
  categoryName?: string;

  /**
   * Id of the category
   */
  categoryId?: number;

  /**
   * Optional hash used to display the map as a miniature image.
   */
  miniatureHash?: string;

  /**
   * Optional hash used to display the map as a full resolution image.
   */
  optimalHash?: string;

  /**
   * Optional hash used to display the map as a SVG.
   */
  svgHash?: string;

  /**
   * Optional: Whether the map can be deleted.
   */
  cannotDelete?: boolean;

  /**
   * Creates an instance of DsMap.
   *
   * @param json the json data
   */
  constructor(json: DsMapInterface | DsDetailedMapInterface) {
    this.id = json.id;
    if ('niveau' in json) {
      this.name = json.niveau;
      this.categoryName = json.batiment;
      this.cannotDelete = !!json.removeOption;
    }
    if ('name' in json) {
      this.name = json.name;
      this.categoryName = json.category;
      this.categoryId = json.categoryId;
      this.miniatureHash = json.miniatureHash;
      this.optimalHash = json.optimalHash;
      this.svgHash = json.svgHash;
      this.cannotDelete = !!json.removeOption;
    }
  }
}
